import type { IconData } from '@stacksjs/iconify-core'

export const darkDislayModeRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.5 24C4.5 13.23 13.23 4.5 24 4.5S43.5 13.23 43.5 24S34.77 43.5 24 43.5S4.5 34.77 4.5 24M24 .5C11.021.5.5 11.021.5 24S11.021 47.5 24 47.5S47.5 36.979 47.5 24S36.979.5 24 .5M10.296 24c0-7.585 6.245-13.705 13.914-13.705c2.92 0 5.633.887 7.874 2.404c1.071.726 1.261 2.114.676 3.13c-.447.776-1.245 1.188-2.025 1.268c-3.571.363-6.333 3.328-6.333 6.903s2.762 6.54 6.332 6.902c.781.08 1.579.492 2.026 1.268c.585 1.016.395 2.404-.676 3.13a14 14 0 0 1-7.875 2.404c-7.668 0-13.913-6.12-13.913-13.704\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default darkDislayModeRemix
